import { Navigate } from 'react-router-dom';

/**
 * RequireAuth - Garde de route
 *
 * Redirige vers /login si :
 *   - aucun token en localStorage (non connecté)
 *   - le rôle de l'utilisateur n'est pas dans allowedRoles
 *
 * Usage :
 *   <RequireAuth allowedRoles={[1]}>
 *     <AdminSalonDashboard />
 *   </RequireAuth>
 */
const RequireAuth = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const role  = parseInt(localStorage.getItem('role'), 10);

  // Non connecté → login
  if (!token) return <Navigate to="/login" replace />;

  // Rôle non autorisé → login
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireAuth;
